import * as React from "react";
import {
  CheckPicker,
  SelectPicker,
  Row,
  Col,
  Button,
  ButtonGroup,
  ButtonToolbar,
  Toggle,
} from "rsuite";
import { submitCrossSellRecommendation } from "../../queries/apiQueries";

export class CrossSellRecommendation extends React.Component<any, any> {
  fontSize = "0.85vw";
  headerStyle = {
    borderTop: "0.2px solid rgb(117, 189, 8)",
    fontSize: "0.8em",
    backgroundColor: "black",
    color: "white",
    borderRight: "0.1px solid #333231",
    borderBottom: "0.2px solid rgb(117, 189, 8)",
  };
  columnStyle = {
    backgroundColor: "#1a1916",
    color: "white",
    fontSize: "0.75em",
    borderRight: "0.1px solid #333231",
    borderBottom: "0.1px solid #333231",
    innerHeight: "36px",
  };
  constructor(props: any) {
    super(props);
    this.state = {
      checked: false,
      checked2: false,
    };
  }

  AsyncToggle = () => {
    // this.setState({ loading: true });
    // setTimeout(() => {
    this.setState({ checked: !this.state.checked });
    // }, 1000);
  };

  AsyncToggleForExecution = () => {
    this.setState({ checked2: !this.state.checked2 });
  };

  handleVolumeChangeHandler = (event: any, d: any, index: any) => {
    this.props?.handleVolumeChangeNew(event, d, index);
    this.props.data[index].adjustedOpportunityRevenue = (event.target.value * this.props.data[index].price).toFixed(2)
    this.props.data[index].adjustedmarginOpportunity = (event.target.value * this.props.data[index].margin).toFixed(2)
    this.props?.manageDataReflection(event, d, index)

  };

  handlePriceChangeHandler = (event: any, d: any, index: any) => {
    this.props?.handlePriceChange(event, d, index);
    this.props.data[index].adjustedOpportunityRevenue = (event.target.value * this.props.data[index].quantity).toFixed(2)
    this.props.data[index].adjustedmarginOpportunity = (this.props.data[index].margin * this.props.data[index].quantity).toFixed(2)
    this.props?.manageDataReflection(event, d, index)

  };

  handleCheckChangeHandler = (event: any, d: any, index: any) => {
    this.props?.handleCheckChange(event, index);
    this.props?.manageDataReflection(event, d, index)
  };

  submitCrossSellRecommendationData = () => {
    submitCrossSellRecommendation().then((response: any) => {
      if (response?.status === 200) {
        this.props?.submitRefresh()
      }
    }).catch((err: any) => {
      console.log(err)
    })
  }

  render(): React.ReactNode {
    const {
      data,
      acceptedData,
      handleCheckChange,
      checked,
      checked2,
      handleVolumeChangeNew,
      handlePriceChange,
      handleSave,
      submitCrossSellExecution,
      saveRecommendation,
      saveRecommendationHandle,
    } = this.props;
    return (
      <Row style={{ height: "100%" }} className="show-grid">
        <Col
          className="subHeadCU subHeadCS"
          style={{ paddingBottom: '2%', paddingLeft: "9%", color: "#ffffff" }}
          xs={24}
          sm={24}
          md={24}
        >
          Recommended items to be sold to Customer
          {/* {(data && data.length > 0) && <Button className="buttonMargin" color="green"
                    style={{ float: "right", color: "white", marginRight: "3px", fontSize: "0.7vw" }}
                    onClick={handleSave} appearance="default">
                    Save
                </Button>} */}
        </Col>
        {data && data.length > 0 ? (
          <Col style={{ height: "40vh", paddingBottom: '12px' }} xs={24} sm={24} md={24}>
            <Row style={{ height: "39vh" }} className="show-grid">
              <table
                style={{ height: "100%" }}
                className="fixed_header crossSell"
              >
                {/* <span className="recommendedSubHead">{data[0].l4}</span> */}
                <tbody
                  className="tbodyClass"
                  style={{ fontSize: this.fontSize, height: "95%" }}
                >
                  <tr className="stickyHeader">
                    <th className="alginCenter" style={this.headerStyle}>
                      Item ID
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      Description
                    </th>
                    {/* <th className="alginCenter" style={this.headerStyle}>Brand</th> */}
                    <th className="alginCenter" style={this.headerStyle}>
                      Recommended Quantity (eaches/year)
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      {" "}
                      Price ($/each)
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      {" "}
                      Margin ($/each)
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      {" "}
                      Opportunity Revenue($)
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      {" "}
                      Opportunity Margin($)
                    </th>
                    <th className="alginCenter" style={this.headerStyle}>
                      Include in this?
                    </th>
                  </tr>
                  {data.map((d: any, index: number) => (
                    <tr>
                      <td className="alignCenter" style={this.columnStyle}>
                        {d.itemId}
                      </td>
                      <td className="alignCenter" style={this.columnStyle}>
                        {d.itemDesc}
                      </td>
                      {/* <td className="alignCenter" style={this.columnStyle}>{d.brand}</td> */}
                      <td className="alignCenter" style={this.columnStyle}>
                        <input
                          className="volumeInputStyle"
                          onChange={(event) =>
                            this.handleVolumeChangeHandler(event, d, index)
                          }
                          type="number"
                          value={d.quantity.toFixed(0)}
                        />
                      </td>
                      <td className="alignCenter" style={this.columnStyle}>
                        <input
                          className="volumeInputStyle"
                          onChange={(event) =>
                            this.handlePriceChangeHandler(event, d, index)
                          }
                          type="number"
                          step="0.01"
                          value={d.price.toFixed(2)}
                        />
                      </td>
                      <td className="alignCenter" style={this.columnStyle}>
                        {"$" + d.margin.toFixed(2)}
                      </td>
                      <td className="alignCenter" style={this.columnStyle}>

                        {"$"+ parseFloat(d.adjustedOpportunityRevenue).toFixed(2)}
                      </td>
                      <td className="alignCenter" style={this.columnStyle}>
                        {"$"+ parseFloat(d.adjustedmarginOpportunity).toFixed(2)}

                      </td>
                      <td className="alignCenter" style={this.columnStyle}>
                        <input
                          type="checkbox"
                          onChange={(event) => this.handleCheckChangeHandler(event, d, index)}
                          defaultChecked={
                            d.include === 1 || acceptedData[d.l4] ? true : false
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <Row className="show-grid">
              <Col style={{ color: "white" }} xs={24} sm={24} md={7} />

              <Col style={{ color: "white" }} xs={24} sm={24} md={8}>
                {/* <label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Agree with recommended info.: </label>
                        <Toggle style={checked ? {} : { backgroundColor: "#6b6a6a" }} checkedChildren="Yes" unCheckedChildren="No" checked={checked} onChange={this.AsyncToggle} /> */}
              </Col>
              <Col xs={24} sm={24} md={3}></Col>
              <Col xs={24} sm={24} md={3}>
                <div
                  className="submitCts"
                  style={{ paddingTop: "3px", textAlign: "left" }}
                >

                  <Button
                    style={{ padding: "4% 19%" , background: '#a4f504b0', color: 'white'}}
                    appearance="default"
                    onClick={this.submitCrossSellRecommendationData}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
              <Col xs={24} sm={24} md={3}>
                <div
                  className="submitCts"
                  style={{ paddingTop: "3px", textAlign: "left" }}
                >
                  <Button
                    style={{ padding: "4% 19%", backgroundColor: saveRecommendation?.itemid && saveRecommendation?.itemid?.length !== 0 ? '#4caf50' : 'gray' , color:'white'}}
                    appearance="default"
                    onClick={() => { saveRecommendation?.itemid && saveRecommendation?.itemid?.length !== 0 ? saveRecommendationHandle() : "" }}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        ) : (
          <span className="divTextCenter">
            Click on the Product Class from the above table to get the Detailed
            view
          </span>
        )}
      </Row>
    );
  }
}
